
define('text!templates/modals/select-deal/goods-collection-item.ejs',[],function () { return '<td class="select-deal-check">\n    <label>\n        <input type="checkbox">\n        <span><%= fullName %></span>\n    </label>\n</td>';});

